<template>
  <section id="admin-background">
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>

    <div style="margin-top:150px; margin-bottom:50px">
      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>
          <form style="padding:10px; margin:30px">
            <h3 v-if="accion == 'Nuevo'" style="text-align:center; padding-bottom:15px">Nuevo Curso</h3>
            <h3
              v-if="accion == 'Modifica'"
              style="text-align:center; padding-bottom:15px"
            >Editar Curso #{{newCurso.id}}</h3>
            <div class="form-group">
              <label>Categoria</label>
              <div>
                <b-form-select v-model="newCurso.categoria" :options="options"></b-form-select>
              </div>
            </div>
            <div class="form-group">
              <label>Nombre del curso</label>
              <input class="form-control" v-model="newCurso.nombre" />
            </div>
            <div class="form-group">
              <label>Qué va a aprender</label>
              <b-form-textarea
                id="textarea"
                v-model="newCurso.aprender"
                placeholder="Ingresá qué va a aprender el arkidian"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>
            <div class="form-group">
              <label>Edad desde</label>
              <b-form-input id="desde" type="number" v-model="newCurso.desde"></b-form-input>
            </div>
            <div class="form-group">
              <label>Edad hasta</label>
              <b-form-input id="hasta" type="number" v-model="newCurso.hasta"></b-form-input>
            </div>
            <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
            <div v-if="successMessage" class="alert alert-success" role="alert">{{successMessage}}</div>
            <div style="text-align:center">
              <button
                v-if="accion=='Nuevo'"
                type="button"
                class="btn btn-primary"
                @click="altaCurso(newCurso)"
              >Grabar curso</button>
              <button
                v-if="accion == 'Modifica'"
                type="button"
                class="btn btn-primary"
                @click="modificarCurso(newCurso)"
              >Modificar curso</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="accion=='Modifica' || cursoNuevo" style="margin-top:20px; margin-bottom:50px">
      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <form style="padding:10px; margin:30px">
            <h3 style="text-align:center; padding-bottom:15px">Contenido</h3>

            <div class="form-group">
              <label>Nombre del contenido</label>
              <input class="form-control" v-model="newContenido.nombre_contenido" />
            </div>
            <div class="form-group">
              <label>URL del video</label>
              <input class="form-control" v-model="newContenido.url_contenido" />
            </div>
            <div class="form-group"></div>
            <div class="form-group">
              <label>URL del thumbnail</label>
              <b-form-input id="desde" type="text" v-model="newContenido.url_imagen"></b-form-input>
            </div>
            <div class="form-group">
              <label>Orden</label>
              <b-form-input id="hasta" type="number" v-model="newContenido.orden"></b-form-input>
            </div>
            <div
              v-if="errorMessageCont"
              class="alert alert-danger"
              role="alert"
            >{{errorMessageCont}}</div>
            <div
              v-if="successMessageCont"
              class="alert alert-success"
              role="alert"
            >{{successMessageCont}}</div>
            <div style="text-align:center">
              <button
                type="button"
                class="btn btn-primary"
                @click="altaContenido(newContenido)"
              >Insertar contenido</button>
            </div>
          </form>

          <div class="card-deck" style="padding:10px; margin:30px">
            <div
              class="card"
              style="margin-bottom:10px; min-width:250px; max-width:250px"
              v-for="contenido in contenidos"
              v-bind:key="contenido.orden"
            >
              <div class="card-body">
                <h1
                  style="   position: absolute;
                                border-radius: 6px;
                                padding: 0px;
                                margin: -30px;
                                background: #ffffff9c;"
                >{{contenido.orden}}</h1>
                <h6>#{{contenido.id_contenido}} {{contenido.nombre_contenido}}</h6>

                <img
                  :src="contenido.url_imagen"
                  id="challenges"
                  alt="Miles de proyectos"
                  style="width:100%;"
                />
                <p><b>Contenido</b> {{contenido.url_contenido}}</p>
                <p><b>Imagen</b> {{contenido.url_imagen}}</p>
              </div>
              <button @click="eliminarContenido(contenido)">Eliminar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="accion == 'Modifica' || cursoNuevo" style="margin-top:20px; margin-bottom:50px">
      <div class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <form style="padding:10px; margin:30px">
            <h3 style="text-align:center; padding-bottom:15px">Desafíos</h3>

            <div class="form-group">
              <label>Nombre del challenge</label>
              <input class="form-control" v-model="newDesafio.nombre_challenge" />
            </div>
            <div class="form-group">
              <label>Explicación del challenge</label>
              <b-form-textarea
                id="textarea"
                v-model="newDesafio.detalle_challenge"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>
            <div class="form-group">
              <label>Orden</label>
              <b-form-input id="hasta" type="number" v-model="newDesafio.orden_challenge"></b-form-input>
            </div>
            <div v-if="errorMessageDes" class="alert alert-danger" role="alert">{{errorMessageDes}}</div>
            <div
              v-if="successMessageDes"
              class="alert alert-success"
              role="alert"
            >{{successMessageDes}}</div>
            <div style="text-align:center">
              <button
                type="button"
                class="btn btn-primary"
                @click="altaDesafio(newDesafio)"
              >Insertar Desafío</button>
            </div>
          </form>

          <div class="card-deck" style="padding:10px; margin:30px">
            <div
              class="card"
              style="margin-bottom:10px;  min-width:250px; max-width:250px"
              v-for="desafio in desafios"
              v-bind:key="desafio.orden_challenge"
            >
              <div class="card-body">
                <h1
                  style="   position: absolute;
                                border-radius: 6px;
                                padding: 0px;
                                margin: -30px;
                                background: #ffffff9c;"
                >{{desafio.orden_challenge}}</h1>
                <h5>#{{desafio.id_challenge}} {{desafio.nombre_challenge}}</h5>
                <p>{{desafio.detalle_challenge}}</p>
              </div>
              <button @click="eliminarDesafio(desafio)">Eliminar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";

export default {
  name: "app",
  computed: {
    ...mapGetters(["pathAPI", "userLogged", "categorias"])
  },
  data() {
    return {
      habilitado: false,
      error: false,

      selected: null,
      options: [],
      newCurso: {
        id: "",
        estado: "",
        categoria: "",
        nombre: "",
        aprender: "",
        desde: "",
        hasta: ""
      },
      newContenido: {
        id_contenido: "",
        orden: "",
        id_curso: "",
        nombre_contenido: "",
        url_contenido: "",
        url_imagen: ""
      },
      newDesafio: {
        id_challenge: "",
        orden_challenge: "",
        id_curso: "",
        nombre_challenge: "",
        detalle_challenge: ""
      },

      errorMessage: "",
      successMessage: "",
      errorMessageCont: "",
      successMessageCont: "",
      errorMessageDes: "",
      successMessageDes: "",
      cursoNuevo: false,
      adulto: false,
      arkidian: false,
      contenidos: [],
      desafios: []
    };
  },
  props: ["accion", "id"],

  methods: {
    altaCurso(curso) {
      self = this;
      self.errorMessage = "";
      self.successMessage = "";

      var bodyApi = "";

      bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&id_categoria=" +
        curso.categoria.id +
        "&nombre_curso=" +
        curso.nombre +
        "&detalle_curso=" +
        curso.aprender +
        "&edad_desde=" +
        curso.desde +
        "&edad_hasta=" +
        curso.hasta +
        "&id_proveedor=1";

      fetch(this.pathAPI + "cursos.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
            } else {
              self.successMessage = "Curso dado de alta";
              self.newCurso.id = result.curso;
              self.cursoNuevo = true;
            }
          });
        } else {
          self.errorMessage = "Hay un error, verificá los datos ingresados";
        }
      });
    },

    modificarCurso(curso) {
      self = this;
      self.errorMessage = "";
      self.successMessage = "";
      var bodyApi;
      bodyApi =
        "id_curso=" +
        curso.id +
        "&usuario=" +
        this.userLogged.user +
        "&id_categoria=" +
        curso.categoria.id +
        "&nombre_curso=" +
        curso.nombre +
        "&detalle_curso=" +
        curso.aprender +
        "&edad_desde=" +
        curso.desde +
        "&edad_hasta=" +
        curso.hasta +
        "&id_proveedor=1" +
        "&estado_curso=" +
        curso.estado;
      fetch(self.pathAPI + "cursos.php?" + bodyApi, {
        method: "PUT",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta;
          respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado === "ERROR") {
              self.errorMessage = result.mensaje;
            } else {
              self.successMessage = "Curso modificado";
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },

    altaContenido(contenido) {
      self = this;
      self.errorMessageCont = "";
      self.successMessageCont = "";

      if (!contenido.nombre_contenido)
        self.errorMensajeCont = "Debés ingresar el nombre del contenido";
      if (!contenido.url_contenido)
        self.errorMensajeCont = "Debés ingresar la URL del contenido";
      if (!contenido.url_imagen)
        self.errorMensajeCont =
          "Debés ingresar la url de la imagen del contenido";
      if (!contenido.orden)
        self.errorMensajeCont = "Debés ingresar el número de orden";

      var bodyApi = "";

      bodyApi =
        "orden=" +
        contenido.orden +
        "&id_curso=" +
        this.newCurso.id +
        "&nombre_contenido=" +
        contenido.nombre_contenido +
        "&url_contenido=" +
        contenido.url_contenido +
        "&url_imagen=" +
        contenido.url_imagen +
        "&usuario=" +
        this.userLogged.user;

      fetch(this.pathAPI + "contenido_curso.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessageCont = result.mensaje;
            } else {
              self.successMessageCont = "Contenido dado de alta";
              self.newContenido.id_contenido = result.id_contenido;
              self.contenidos.push({
                id_contenido: result.id_contenido,
                orden: contenido.orden,
                id_curso: self.newCurso.id,
                nombre_contenido: contenido.nombre_contenido,
                url_contenido: contenido.url_contenido,
                url_imagen: contenido.url_imagen
              });

              self.newContenido.id_contenido = "";
              self.newContenido.orden = "";
              self.newContenido.id_curso = "";
              self.newContenido.nombre_contenido = "";
              self.newContenido.url_contenido = "";
              self.newContenido.url_imagen = "";
            }
          });
        } else {
          self.errorMessageCont = "Hay un error, verificá los datos ingresados";
        }
      });
    },

    eliminarContenido(contenido) {
      self = this;
      self.errorMessageCont = "";
      self.successMessageCont = "";

      fetch(
        this.pathAPI +
          "contenido_curso.php?id_contenido=" +
          contenido.id_contenido +
          "&usuario=" +
          this.userLogged.user,
        {
          method: "DELETE"
        }
      ).then(function(response) {
        for (var i = 0; i < self.contenidos.length; i++) {
          if (self.contenidos[i].id_contenido === contenido.id_contenido) {
            self.contenidos.splice(i, 1);
          }
        }
      });
    },

    altaDesafio(desafio) {
      self = this;
      self.errorMessageDes = "";
      self.successMessageDes = "";

      if (!desafio.orden_challenge) {
        self.errorMessageDes = "Debés ingresar el número de orden del desafío";
        return;
      }
      if (!desafio.nombre_challenge) {
        self.errorMessageDes = "Debés ingresar el nombre del desafío";
        return;
      }
      if (!desafio.detalle_challenge) {
        self.errorMessageDes = "Debés ingresar el detalle del desafío";
        return;
      }

      var bodyApi = "";

      bodyApi =
        "orden_challenge=" +
        desafio.orden_challenge +
        "&id_curso=" +
        self.newCurso.id +
        "&nombre_challenge=" +
        desafio.nombre_challenge +
        "&detalle_challenge=" +
        desafio.detalle_challenge +
        "&usuario=" +
        this.userLogged.user;

      fetch(this.pathAPI + "challenges_cursos.php", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var respuesta = response.json();
          respuesta.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessageDes = result.mensaje;
            } else {
              self.successMessageDes = "Desafío dado de alta";
              self.newDesafio.id_challenge = result.id_challenge;
              self.desafios.push({
                id_challenge: result.id_challenge,
                orden_challenge: desafio.orden_challenge,
                id_curso: self.newCurso.id,
                nombre_challenge: desafio.nombre_challenge,
                detalle_challenge: desafio.detalle_challenge
              });

              self.newDesafio.id_challenge = "";
              self.newDesafio.orden_challenge = "";
              self.newDesafio.id_curso = "";
              self.newDesafio.nombre_challenge = "";
              self.newDesafio.detalle_challenge = "";
            }
          });
        } else {
          self.errorMessageDes = "Hay un error, verificá los datos ingresados";
        }
      });
    },

    eliminarDesafio(desafio) {
      self = this;
      self.errorMessageDes = "";
      self.successMessageDes = "";

      fetch(
        this.pathAPI +
          "challenges_cursos.php?id_challenge=" +
          desafio.id_challenge +
          "&usuario=" +
          this.userLogged.user,
        {
          method: "DELETE"
        }
      ).then(function(response) {
        for (var i = 0; i < self.desafios.length; i++) {
          if (self.desafios[i].id_challenge === desafio.id_challenge) {
            self.desafios.splice(i, 1);
          }
        }
      });
    },

    volver() {
      this.$router.push({ path: "/Cursos" });
    },

    buscarCurso(curso) {
      var fetchApi =
        this.pathAPI +
        "cursos.php?usuario=" +
        this.userLogged.user +
        "&id_curso=" +
        curso;
      fetch(fetchApi)
        .then(response => response.json())
        .then(data => {
          var i;
          for (i = 0; i < this.categorias.length; i++) {
            if (this.categorias[i].id == data.id_categoria) {
              this.newCurso.categoria = this.categorias[i];
            }
          }

          this.newCurso.nombre = data.nombre_curso;
          this.newCurso.aprender = data.detalle_curso;
          this.newCurso.desde = data.edad_desde;
          this.newCurso.hasta = data.edad_hasta;
          this.newCurso.id = data.id_curso;
          this.newCurso.estado = data.estado_curso;
        });
    },

    buscarContenido(curso) {
      var fetchApi =
        this.pathAPI +
        "contenido_curso.php?usuario=" +
        this.userLogged.user +
        "&id_curso=" +
        curso;
      fetch(fetchApi)
        .then(response => response.json())
        .then(data => {
          this.contenidos = data;
        });
    },

    buscarDesafios(curso) {
      var fetchApi =
        this.pathAPI +
        "challenges_cursos.php?usuario=" +
        this.userLogged.user +
        "&id_curso=" +
        curso;
      fetch(fetchApi)
        .then(response => response.json())
        .then(data => {
          this.desafios = data;
        });
    }
  },

  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.habilitado = true;
      console.log(this.categorias)
      for (var i = 0; i < this.categorias.length; i++) {
        this.options.push({
          value: this.categorias[i],
          text: this.categorias[i].nombre
        });
      }
      if (this.accion == "Modifica") {
        this.buscarCurso(this.id);
        this.buscarContenido(this.id);
        this.buscarDesafios(this.id);
      }
    }
    const loader = document.querySelector(".loader");
    loader.className += " hidden";
  }
};
</script>


<style scoped>
#admin-background {
  background: url("/public/images/site/background-modal-admin.svg");
  background-repeat: repeat-x;
  background-size: 1000px;
  display: table;
  width: 100%;
  background-position-y: top;
}
.login {
  width: 90%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}
.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/NewCourse.vue